// constants
const CONSTANTS = require('../constants').OMNITURE;
const _ = require( 'lodash' );

/**
 * try a specified number of times in case call fails
 */
function attemptCall( cb, attempts ) {

    attempts = attempts || 0;

    if ( ++attempts > CONSTANTS.MAX_ATTEMPTS ) return;

    try {
        cb();
    } catch( e ) {
        setTimeout( attemptCall.bind( null, cb, attempts ), CONSTANTS.RETRY_DELAY );
    }

}
/**
 * Track the click events
 * @param event - Object with the following properties:
 *        name - the event name
 *        section - if the user clicks within a category
 *        destination - if it's a link, the URL of the link
 *        isSocial - if the click is for a social category
 */
function clickEvent(event) {
    var contextVars = {};
    var url = event.url || window.location.href;

    contextVars['pageName'] = event.section ? CONSTANTS.PAGE_NAME + '|' + event.section : CONSTANTS.PAGE_NAME;
    contextVars['v.destination'] = event.destination ? event.destination : CONSTANTS.CLICK_NO_DEST;
    contextVars['v.actName'] = 'clicks on ' + event.name;
    contextVars['v.pageType'] = CONSTANTS.PAGE_TYPE;
    contextVars['v.pageURL'] = url;
    contextVars['v.pageFranchise'] = CONSTANTS.PAGE_FRANCHISE;
    contextVars['v.appName'] = CONSTANTS.APP_NAME;
    contextVars['v.vendor'] = CONSTANTS.VENDOR;
    contextVars['v.brandID'] = CONSTANTS.BRAND_ID;
    contextVars['v.activity'] = CONSTANTS.CLICK_ACTIVITY;
    contextVars['v.pv'] = 'false';
    contextVars['linkType'] = CONSTANTS.CLICK_LINK_TYPE;
    contextVars['v.channel'] = CONSTANTS.PAGE_CHANNEL;
    contextVars['v.pageEvent'] = CONSTANTS.PAGE_EVENT;
    contextVars['v.language'] = CONSTANTS.LANGUAGE;
    contextVars['v.countryName'] = CONSTANTS.COUNTRY_NAME;
    contextVars['v.actPageName'] = url;

    if(event.isSocial) {
      contextVars['v.modname'] = CONSTANTS.MOD_NAME_SOCIAL;
    } else {
      contextVars['v.modname'] = event.modname || CONSTANTS.MOD_NAME;
    }

    if( window.Bento ) {
        window.Bento.onPageEvent(contextVars);
    }
}
/**
 * Track page events
 */
function pageEvent(event) {
    var pageName = event.page ? CONSTANTS.PAGE_NAME + '|' + event.page : CONSTANTS.PAGE_NAME;
    var url = event.url || window.location.href;
    
    var contextVars = {};
    contextVars['pageName'] = pageName;
    contextVars['v.channel'] = CONSTANTS.PAGE_CHANNEL;
    contextVars['v.pageType'] = CONSTANTS.PAGE_TYPE;
    contextVars['v.pageFranchise'] = CONSTANTS.PAGE_FRANCHISE;
    contextVars['v.pageSeries'] = CONSTANTS.PAGE_SERIES;
    // contextVars['v.prevPageName'] = CONSTANTS.PREV_PAGE_NAME;
    contextVars['v.pageURL'] = url;
    contextVars['v.pageEvent'] = CONSTANTS.PAGE_EVENT;
    contextVars['v.webVersion'] = CONSTANTS.WEB_VERSION;
    contextVars['v.brandID'] = CONSTANTS.BRAND_ID;
    contextVars['v.language'] = CONSTANTS.LANGUAGE;
    contextVars['v.countryName'] = CONSTANTS.COUNTRY_NAME;
    contextVars['v.vendor'] = CONSTANTS.VENDOR;
    contextVars['v.activity'] = CONSTANTS.PAGE_ACTIVITY;
    contextVars['v.pv'] = 'true';
    contextVars['v.appName'] = CONSTANTS.APP_NAME;
    contextVars['v.vidFranchise'] = CONSTANTS.PAGE_VID_FRANCHISE;

    if( window.Bento ) {
        window.Bento.onNewPage(contextVars);
    }
}

document.addEventListener('omnitureClickEvent', function(event) {
    clickEvent( event.detail );
});

module.exports = {
    /**
     * send an omniture click event
     */
    sendClickEvent: function( event ) {
        attemptCall( clickEvent.bind( null, event ));
    },
    /**
     * send an omniture page event
     */
    sendPageEvent: function( pageName ) {
        attemptCall( pageEvent.bind( null, pageName ));
    }
};




// WEBPACK FOOTER //
// ./app/scripts/util/omniture.js